import header from '../modules/header/index';
import productJS from '../modules/product';
import {Apptus} from '../modules/apptus/apptus';
import ActivateTabFunc from '../modules/tabPanel/components/activateTabFunc';
import profileJs from '../modules/profile/profile';
import NewsletterAction from '../modules/newsletterAction';
import initStarRating from '../modules/tabPanel/components/initStarRating';
import InitTab from '../modules/tabPanel/components/initTab';
import addScrollToTop from '../modules/addScrollToTop';
import passiveListenersForJquery from '../modules/passiveListenersForJquery';

import "../../../scss/pages/productPage.scss";

jQuery(function() {
  passiveListenersForJquery();
  header();
  productJS();
  profileJs();
  initStarRating();
  InitTab();
  addScrollToTop();

  $('.subscription').on('click', function() {
    NewsletterAction($(this));
  });
  $(".btn-back").not(".no-history").on("click", function () {
    history.back();
  });
  $(window).on('click', function(e) {
    let target = e.target;
    var targetParent = $(target).parent();
    
    if(targetParent.hasClass("tab1")) {
      ActivateTabFunc($(targetParent));
    }
    if(targetParent.hasClass("tab2")) {
      ActivateTabFunc($(targetParent));
    }
    if(targetParent.hasClass("tab3")) {
      ActivateTabFunc($(targetParent));
    }
    if(targetParent.hasClass("tab4")) {
      ActivateTabFunc($(targetParent));
    }
    if(target.matches('.update-apptus-func') ) {
      Apptus.NotifyClick($(target).attr('data-apptus'))
    }
    if(targetParent.hasClass('update-apptus-func') ) {
      Apptus.NotifyClick($(targetParent).attr('data-apptus'))
    }
  })
})
